<ppl-box-container [small]="small">
  @if (title) {
    <div class="title">{{ title }}</div>
  }
  @if (description) {
    <div class="description">
      {{ description }}
    </div>
  }

  <ng-content></ng-content>
</ppl-box-container>
